module.exports = __webpack_public_path__ + "img/iconHome.6c1ced04.png";